import React from 'react';

import { NoAppsAvailablePage } from '../components/NoAppsAvailablePage';
import { useVisibleApps, type VisibleApp } from '../hooks/use-visible-apps';

type AppAccessGateProps = {
	appName: VisibleApp['name'];
	children: React.ReactNode;
	fallback?: React.ReactNode;
};

export const AppAccessGate = ({
	appName,
	children,
	fallback = null,
}: AppAccessGateProps): React.JSX.Element | null => {
	const { apps, loading } = useVisibleApps();
	const hasAccess = apps.some((app) => app.name === appName);

	if (loading) {
		return <>{fallback}</>;
	}

	if (!hasAccess) {
		return <NoAppsAvailablePage />;
	}

	return <>{children}</>;
};
